import style from "./SettingsTabs.module.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Icon from "@/ui/icon/Icon";

function SettingsTabs({ currentTab }) {
	const { t } = useTranslation();

	const settingsTabs = [
		{
			name: t("common:nav.settings"),
			path: "/settings/",
			icon: "fa-cog",
		},
		{
			name: t("settings:password.title"),
			path: "/settings/change-password/",
			icon: "fa-lock",
		},
		{
			name: t("settings:tabs.billing"),
			path: "/settings/billing/",
			icon: "fa-credit-card",
		},
	];

	return (
		<div className={style.tabsHolder}>
			{settingsTabs.map((tab) => (
				<SettingsTab
					key={tab.path}
					path={tab.path}
					isCurrent={
						currentTab == tab.path.split("/").filter(Boolean).pop()
					}
				>
					<Icon icon={tab.icon} />
					<span>{tab.name}</span>
				</SettingsTab>
			))}
		</div>
	);
}

function SettingsTab({ path, isCurrent, children }) {
	return (
		<Link
			to={path}
			className={`${style.tab} ${isCurrent ? style.active : ""}`}
		>
			{children}
		</Link>
	);
}

export default SettingsTabs;
